import { render, staticRenderFns } from "./SelectTradeMethod.vue?vue&type=template&id=bd675564&scoped=true&"
import script from "./SelectTradeMethod.vue?vue&type=script&lang=js&"
export * from "./SelectTradeMethod.vue?vue&type=script&lang=js&"
import style0 from "./SelectTradeMethod.vue?vue&type=style&index=0&id=bd675564&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd675564",
  null
  
)

export default component.exports